// Components
import Button from "../../../components/Button/ButtonContainer";
import { CardContainer as Card } from "../../../components/Card/CardContainer";
import Section from "../../../components/Section/SectionContainer";

// CSS
import styles from "../conferences.module.scss";

const ConferencesVideos = (props) => {
    const { history, videos } = props;

    function handleSelect(video) {
        history.push({ pathname: `/videos/${video.id}`, state: { video } });
    }

    function onButtonClick() {
        history.push("/videos");
    }

    function renderVideos() {
        return videos
            .slice(0, 3)
            .map((video) => (
                <Card
                    data={video}
                    key={video?.id}
                    onClick={() => handleSelect(video)}
                />
            ));
    }

    return (
        <Section classes={styles.videos}>
            <h1>featured videos</h1>
            <div className={styles.grid}>{renderVideos()}</div>
            <Button onClick={onButtonClick} text="more videos" theme="green" />
        </Section>
    );
};

export default ConferencesVideos;
